// import menu from '../constants/menu.json';
import adminMenu from "../constants/adminMenu.json";
import taskReport from "../constants/taskReport.json";
import SubMenu from "../components/SubMenu";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../redux/authSlice";
import React, { useEffect, useState } from "react";
import { getUserData } from "../utils/localStorage";

const SideBar = () => {
  const dispatch = useDispatch();
  const handleToggleSidebar = () => dispatch(toggleSidebar());

  const { userProfileData } = getUserData();

  const role = userProfileData?.role;

  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li
          className="nav-item card"
          sx={{ color: "#012970" }}
          onClick={handleToggleSidebar}
        >
          <Link className={`nav-link collapsed`} to={"/"}>
            <i className={"bi bi-house"} />
            <span>{"Home"}</span>
          </Link>
        </li>

        {(role === "ROLE_SUPER_ADMIN" || role === "ROLE_ADMIN") &&
          <>
            <li
              className="nav-item card"
              sx={{ color: "#012970" }}
              onClick={handleToggleSidebar}
            >
              <Link className={`nav-link collapsed`} to={"masters"}>
                <i className={"bi bi-house"} />
                <span>{"Masters"}</span>
              </Link>
            </li>
            <li
              className="nav-item card"
              sx={{ color: "#012970" }}
              onClick={handleToggleSidebar}
            >
            <Link className={`nav-link collapsed`} to={"lead/list"}>
                <i className={"bi bi-house"} />
                <span>{"Leads"}</span>
              </Link>
            </li>
          </>
        }

        {(role === "ROLE_TELECALLER" || role === "ROLE_SUPER_TELECALLER") &&
          <>
          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"lead/list"}>
              <i className={"bi bi-house"} />
              <span>{"Leads"}</span>
            </Link>
          </li>
          </>
        }

        {(role === "ROLE_OPERATION") &&
          <>
          <li
            className="nav-item card"
            sx={{ color: "#012970" }}
            onClick={handleToggleSidebar}
          >
            <Link className={`nav-link collapsed`} to={"operation-lead/list"}>
              <i className={"bi bi-house"} />
              <span>{"Leads"}</span>
            </Link>
          </li>
          </>
        }

      </ul>
    </aside>
  );
};
export default SideBar;
